<ng-container *ngIf="supplementApplication">
    <h2>Komplettera legitimation med fler behörigheter</h2>
    <p>
        Du som redan har en legitimation kan här komplettera den med fler behörigheter. Det gäller exempelvis dig som
        har
        tagit en ny behörighetsgivande examen, eller har lång undervisningserfarenhet eller högskolestudier i ett ämne
        som
        inte ingår i din nuvarande behörighet.
        <br />
        Det kostar 990 kronor att ansöka om att utöka din lärarlegitimation eller förskollärarlegitimationen med fler
        behörigheter.
    </p>
</ng-container>
<h2>Mina kontaktuppgifter</h2>

<div>
  <app-input [control]="address" data-test-id="applicantAddress">Adress (postadress, postnummer och ort)</app-input>
  <app-input [control]="phone" data-test-id="applicantPhone">Telefonnummer (frivilligt)</app-input>
</div>

<ng-template #loading>
    <mat-spinner diameter="72"></mat-spinner>
</ng-template>
